require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./javascript-algorithms-and-data-structures-es-6-prevent-object-mutation.json") })
        }
      }, "path---javascript-algorithms-and-data-structures-es-6-prevent-object-mutation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---javascript-algorithms-and-data-structures-es-6-prevent-object-mutation!./.cache/json/javascript-algorithms-and-data-structures-es-6-prevent-object-mutation.json
// module id = 2377
// module chunks = 231608221292675